import { useEffect } from 'react';
import type { IUserData } from '@shared/types';
import { navigate } from '@/features/routing';

export const HandleLoggedIn = ({ userData }: { userData: IUserData }) => {
  useEffect(() => {
    const nextPage = userData.startingPage || '/';
    navigate(nextPage, { replace: true });
  }, [userData, navigate]);

  return null;
};
